import React, { useState } from 'react'
import GenericModal from '../generic-modal/generic-modal'
import './comments-report.scss'
import Button from '../../atoms/button/button'
import StandardModal from '../standard-modal/standard-modal'
import MagazineService from '../../../services/magazine'

const CommentsReport = props => {
    const {setModalState,commentaryId, resetComentary}= props
    const [comentary, setComentary] = useState("")
    const [motive, setMotive] = useState("CONTENIDO_INAPROPIADO")

    const handleClose=()=>{
            setModalState(<></>)  
    }
    const handleSendReport=()=>{
        var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken;
        var config = {
            headers: {
                Authorization: tokenId,
            }
        }
        var payload={
            commentId: commentaryId,
            reason: motive,
            reasonDetail: comentary
        }
        MagazineService.setCommentsReport(payload,config).then(res=>{
            setComentary("");
            if(res.status === 200){
                setModalState(<StandardModal
                    title='Gracias, hemos recibido tu denuncio'
                    subtitle=''
                    description='Si vemos que este contenido infringe nuestras normas , lo retiraremos.'
                    noButton={true}
                    click={() => {  setModalState(<></>)  }}
                />)
                resetComentary();
            }else{
                setModalState(<StandardModal
                    title='¡Ups!'
                    subtitle=''
                    description='Ha ocurrido un error, intentalo mas tarde.'
                    noButton={true}
                    click={() => {  setModalState(<></>)  }}
                />)
            }
        }).catch(e => console.log(e))

       
    }
    return (
        <GenericModal>
            <div className="f-modal-info">
                <div className="f-main-title-container">
                    <label className="f-main-title">
                        NOSOTRAS
                    </label>
                </div>
                <div className="f-sub-title-container-generic">
                        <label className="f-sub-title">
                        ES UNA ZONA SEGURA
                        </label>
                </div>
                <p className="f-modal-info-copy">
                    Recuerda que debes denunciar un contenido cuando es ofensivo o violento, si no cumple con ninguna de estas condiciones y 
                    simplemente no te gusta, esta no es una razón válida para denunciar.
                    <br />
                    <br />
                    <span>Elige por qué quieres denunciar este comentario:</span>
                </p>
                <div className="f-modal-info-buttons">
                    <div onClick={()=>setMotive("CONTENIDO_INAPROPIADO")}>
                        <Button className={motive==="CONTENIDO_INAPROPIADO" ? "secondary-blue active": "secondary-blue "} title="Es contenido molesto e inapropiado" />
                    </div>
                    <div onClick={()=>setMotive("CONTENIDO_VIOLENTO")}>
                        <Button className={motive==="CONTENIDO_VIOLENTO" ? "secondary-blue active": "secondary-blue "} title="Es contenido violento" />
                    </div>
                   
                </div>
                <p className="f-modal-info-copy">
                    Cuéntanos aquí más sobre el motivo de tu denuncia
                </p>
                <textarea maxLength="500"  value={comentary} placeholder="Escribe tu comentario" onChange={e=>setComentary(e.target.value)}/>

            </div>
            <span onClick={handleClose} className="f-icon-close-comments icon2-close"></span>
            <div className={!comentary ? "disable": ""} onClick={handleSendReport}>
            <Button className="primary-pink short" title="Enviar"/>
            </div>
            <br />
        </GenericModal>
    )
}

export default CommentsReport
